import React from 'react';

interface Props {
    activeColor:string
}
const DrawerIcon = (props:Props) => {
    return (
        <svg width="25" height="17" viewBox="0 0 25 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="25" height="3" fill={props.activeColor}/>
            <rect y="7" width="25" height="3"fill={props.activeColor}/>
            <rect y="14" width="25" height="3" fill={props.activeColor}/>
        </svg>
    );
};

export default DrawerIcon;